import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getCargoItems: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEMS,
	},
	getCargoItem: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM,
	},
	createCargoItem: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].CREATE_CARGO_ITEM,
	},
	putCargoItem: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].PUT_CARGO_ITEM,
	},
	patchCargoItem: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].PATCH_CARGO_ITEM,
	},
	deleteCargoItem: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].DELETE_CARGO_ITEM,
	},
	getCargoItemPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_PREVIEW,
	},
	getCargoItemPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_POPUP,
	},
}
